import type { ReqGuardActionName, ReqGuardSnapshot } from '../types/req-guard-chat.js'

/**
 * Page actions the Requirement Doctor chat may take given what the page currently shows.
 * Shared so the server (which tools the model is offered) and the browser (re-check right
 * before executing) apply the same rule. There is deliberately no action that applies
 * proposals to the spec, approves or deletes a requirement — the Chat can at most open the
 * page's own confirmation, and the person presses the button there.
 */
export function availableReqGuardTools(snapshot: ReqGuardSnapshot | undefined): ReqGuardActionName[] {
  if (!snapshot || snapshot.busy) return []
  const tools: ReqGuardActionName[] = ['open_tab', 'run_coverage']
  if ((snapshot.coverage.latest?.proposals.length ?? 0) > 0) tools.push('set_proposal_decisions')
  if (snapshot.coverage.latest?.proposals.some(p => p.accepted)) tools.push('propose_apply_coverage')
  const { review } = snapshot
  // Mid-flow wizard screens (analysis running, a fix being applied or edited) are left alone.
  if (['import', 'select', 'review'].includes(review.screen)) tools.push('import_requirements')
  if (review.screen === 'select' && review.requirements.length > 0) tools.push('analyze_requirements')
  if (review.screen === 'review' && review.requirements.some(r => r.score !== undefined)) tools.push('open_requirement', 'start_fix')
  if (review.screen === 'select' && review.requirements.length > 0) tools.push('select_requirements')
  if ((review.screen === 'select' || review.screen === 'review') && review.requirements.length > 0) {
    tools.push('propose_delete', 'propose_force_approve')
  }
  return tools
}
